
function updateReactionsCount(itemId, itemType, reactions) {
    return {
        open: false,
        itemId: itemId,
        itemType: itemType,
        reactionsBreakdownEmojis: {
            'LIKE': {
                'emoji': '&#10084;&#65039;',
                'count': 0
            },
            'WOW': {
                'emoji': '&#128525;',
                'count': 0
            },
            'FIRE': {
                'emoji': '&#128293;',
                'count': 0
            }
        },
        reactions: JSON.parse(reactions),
        total: 0,
        total_string: '',
        init() {
            const vm = this
            vm.buildReactionsBreakdown();

            document.addEventListener(`reactionChanged-${vm.itemId}-${vm.itemType}`, function (event) {
                event.preventDefault();
                // Update on the fly
                let reactionType = event.detail.reaction;
                vm.reactionsBreakdownEmojis[reactionType].count = event.detail.added ? (vm.reactionsBreakdownEmojis[reactionType].count + 1) : (vm.reactionsBreakdownEmojis[reactionType].count - 1)

                // Get accurate count
                vm.getReactionsCount();
            })
        },
        buildReactionsBreakdown() {
            let vm = this
            let likeCount = 0;
            Object.keys(vm.reactions.breakdown).forEach(key => {
                if (key == 'WISHLIST' || key == 'LIKE') {
                    likeCount += parseInt(vm.reactions.breakdown[key])
                } else {
                    vm.reactionsBreakdownEmojis[key].count = parseInt(vm.reactions.breakdown[key]) > 0 ? parseInt(vm.reactions.breakdown[key]) : 0
                }
            })
            vm.reactionsBreakdownEmojis.LIKE.count = likeCount;
            vm.getTotal();
        },
        getTotal() {
            const vm = this
            let total = 0;

            for (let reaction in vm.reactionsBreakdownEmojis) {
                total += (vm.reactionsBreakdownEmojis[reaction]?.count && parseInt(vm.reactionsBreakdownEmojis[reaction].count) > 0 ? parseInt(vm.reactionsBreakdownEmojis[reaction].count) : 0);
            }

            vm.total = total;

            if (total > 0) {
                let formattedTotal = Math.round(total >= 1000 ? total / 1000 : total)
                vm.total_string = (formattedTotal + (total >= 1000 ? 'k' : ''));
            }


        },
        async getReactionsCount() {
            const vm = this

            let params = JSON.stringify({
                item_id: vm.itemId,
                item_type: vm.itemType
            });

            const response = await fetch('/backend/favourites/get_reactions_breakdown', {
                headers: {
                    "Content-Type": "application/json",
                },
                method: 'POST',
                body: params
            })

            const result = await response.json();
            const data = result.data;
            vm.reactions = data.reactions
            vm.buildReactionsBreakdown();

            // Update snippet footer counter
            let updatedNumber = vm.reactions.total_reactions
            updatedNumber = updatedNumber > 0 ? updatedNumber : 0;
            let counters = document.querySelectorAll(`.js-reactions-count-${vm.itemId}`)
            if (counters.length === 0) { // Temp fix for posts
                return
            }
            counters.forEach((el) => {
                if (updatedNumber > 0) {
                    el.classList.remove('d-none')
                }
                let countText = updatedNumber > 0 ? (vm.total_string + (updatedNumber > 1 ? ' likes' : ' like')) : ''
                el.innerText = countText
            })

        },
        openBreakdown(event) {
            event.preventDefault();
            event.stopPropagation();
            this.open = true
        },
        close() {
            this.open = false
        },
    }
}

export default updateReactionsCount
